import { useRef, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const FinalCTA = () => {
  const [visible, setVisible] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) setVisible(true); },
      { threshold: 0.2 }
    );
    if (ref.current) observer.observe(ref.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={ref} className="py-24 bg-navy relative overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0 z-0">
        <img
          src="https://public.readdy.ai/ai/img_res/0b0186cc319ce06cd601842314eaf465.jpg"
          alt="Minneapolis skyline"
          className="w-full h-full object-cover object-top opacity-15"
        />
        <div className="absolute inset-0 bg-navy/90"></div>
      </div>

      {/* Decorative */}
      <div className="absolute inset-0 z-0 pointer-events-none overflow-hidden">
        <div className="absolute top-1/2 -translate-y-1/2 -left-24 w-64 h-64 border border-teal/15 rounded-full"></div>
        <div className="absolute top-1/2 -translate-y-1/2 -right-24 w-64 h-64 border border-teal/15 rounded-full"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 lg:px-8 text-center">
        <div className={`transition-all duration-700 ${visible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-8'}`}>
          <div className="inline-flex items-center gap-2 bg-teal/20 border border-teal/30 rounded-full px-4 py-2 mb-8">
            <i className="ri-shield-check-fill text-teal text-sm"></i>
            <span className="text-teal text-xs font-body font-medium">Licensed · Insured · Family-Owned</span>
          </div>

          <h2 className="font-heading font-800 text-white text-4xl lg:text-6xl mb-6 leading-tight">
            Ready for a{' '}
            <span className="text-teal">Stress-Free</span> Move?
          </h2>

          <p className="text-text-muted font-body text-lg max-w-2xl mx-auto mb-10 leading-relaxed">
            TrueCare Moving Services has helped 500+ Minneapolis families and businesses move with confidence. Get your free, transparent quote today — no obligation, no hidden fees.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-10">
            <Link
              to="/#quote"
              className="inline-flex items-center gap-2 bg-teal hover:bg-teal-dark text-navy font-heading font-700 px-10 py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-base animate-pulse-teal"
            >
              <i className="ri-file-text-line text-lg"></i>
              Get Free Quote
            </Link>
            <a
              href="tel:+16123674481"
              className="inline-flex items-center gap-2 border-2 border-white/30 hover:border-teal text-white hover:text-teal font-heading font-600 px-10 py-4 rounded-xl transition-all duration-200 whitespace-nowrap cursor-pointer text-base"
            >
              <i className="ri-phone-fill text-lg"></i>
              Call (612) 367-4481
            </a>
          </div>

          <div className="flex flex-wrap items-center justify-center gap-6">
            {[
              { icon: 'ri-star-fill', text: '5-Star Rated' },
              { icon: 'ri-award-line', text: 'A+ BBB Rated' },
              { icon: 'ri-shield-check-line', text: 'Licensed & Insured' },
              { icon: 'ri-time-line', text: 'Mon–Sat 7am–10pm' },
            ].map((item) => (
              <div key={item.text} className="flex items-center gap-2">
                <div className="w-4 h-4 flex items-center justify-center">
                  <i className={`${item.icon} text-teal text-sm`}></i>
                </div>
                <span className="text-white/50 font-body text-sm">{item.text}</span>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FinalCTA;
